export function displayErrors(errors) {
  return Object.values(errors).some((error) => { return error != '' })
}

export function encode(data) {
  const formData = new FormData();

  for (const key of Object.keys(data)) {
    if(key === 'graphic') {
      formData.append(key, data[key], data[key].name)
    } else { formData.append(key, data[key]) }
  }

  return formData;
}

export function isImage(type) {
	switch (type) {
		case 'image/jpeg':
		case 'image/png':
		case 'image/gif':
		case 'image/webp':
				return true;
		}
		return false;
}

export function  objectValueExistsInArray(array, value) {
	return array.some((obj) => { return obj.value == value })
}